import React, { useState } from 'react';
import SNR_BNFTS_V1_Header from '../../Includes/Layouts/ADV_1/SNR_BNFTS_V1_Header';
import SNR_BNFTS_V1_Main from '../../Includes/Layouts/ADV_1/SNR_BNFTS_V1_Main';
import AdtopiaLoadAP from '../../../Utility/AdtopiaLoadAP';
import { Months } from '../../../Constants/Constants';

const SNR_BNFTS_V1 = () => {
  var now = new Date();
  const year = now.getFullYear();
  const date = now.getDate();
  const monthIndex = now.getMonth();
  const monthName = Months[monthIndex];
  const formatted = ` ${monthName} ${date}, ${year}`;
  return (
    <>
      <AdtopiaLoadAP pageType="AP" splitName="2025_art/senior_benefits/v1" />
      <div className="SNR_BNFTS_V1">
        <SNR_BNFTS_V1_Header />
        <SNR_BNFTS_V1_Main />
      </div>
    </>
  );
};

export default SNR_BNFTS_V1;
